import React, { useEffect, useState, useMemo } from "react";
// import { useEffect } from "react";
// import { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Divider, Empty, message, Select, Spin, Modal, Popconfirm, Descriptions, Input, DatePicker } from "antd";
import moment from "moment";

import CommonDivWidget from "components/CommonDivWidget/CommonDivWidget";
import CommonButton from "components/ButtonWidgets/CommonButton/CommonButton";
import "./RegistrationPage.css";
import ClubBoxWidget from "components/ClubBoxWidget/ClubBoxWidget";
import {
  apiDeleteRegInfo,
  apiGetRegGroupData,
  apiGetRegistrationDetail,
  apiGetRegistrationDetailByGroup,
  apiGetRegistrationDetailByLabel,
  apiGetRegistrationList,
  apiUpdateCampRegInfo,
  apiUpdateRegInfo,
  apiGetColumnPreferences,
  apiSaveColumnPreferences,
  apiGetTransactionsList,
  apiUpdateTransactionPayStatus,
  apiGetRegistrationTotals,
  apiGetRegistrationTotalParticipants,
  apiDeleteTransaction,
  apiVoidTransaction,
  apiRefundTransaction,
  apiStaxVoidTransaction,
  apiStaxRefundTransaction,
  apiSendInvoiceReceipt,
  apiGetRegistrationPaymentSettings,
  apiGetRegistrationSettings,
  apiGetFacilityApplications,
  apiApproveFacilityApplication,
  apiRejectFacilityApplication,
  apiDeleteFacilityApplication,
  apiCreateFacilityReservation,
  apiGetFacilityCalendar,
} from "services/dashboardService";
import { getDefaultColumnPreferences } from "./RegFormTable/columnConfig";
import ColumnPickerModal from "./ColumnPickerModal/ColumnPickerModal";
import RegFormTable from "./RegFormTable/RegFormTable";
import SearchWidget from "./SearchWidget/SearchWidget";
import GroupTable from "./GroupTable/GroupTable";
import RightDetailWidget from "./RightDetailWidget/RightDetailWidget";
import CampRightDetailWidget from "./RightDetailWidget/CampRightDetailWidget";
import TransactionDetailModal from "./TransactionDetailModal/TransactionDetailModal";
import RegistrationsTable from "./RegistrationsTable/RegistrationsTable";
import RegistrationTotalsTable from "./RegistrationTotalsTable/RegistrationTotalsTable";
import InvoiceModal from "./InvoiceModal/InvoiceModal";
import RefundModal from "./RefundModal/RefundModal";
import FacilityApplicationsTable from "./FacilityApplicationsTable/FacilityApplicationsTable";
import FacilityCalendarWidget from "./FacilityCalendarWidget/FacilityCalendarWidget";
import RejectReasonModal from "./RejectReasonModal/RejectReasonModal";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { ROUTE_REGISTRATION_DETAIL } from "navigation/CONSTANTS";
const RegistrationPage = (props) => {
  const userDataStore = useSelector((x) => x.userDataStore);
  const appDataStore = useSelector((x) => x.appDataStore);
  const history = useHistory()
  const [isBusy, setIsBusy] = useState(false);
  const [userList, setUserList] = useState([]);
  const [srcList, setSrcList] = useState([]);
  const [tripList, setTripList] = useState([]);
  const [groupList, setGroupList] = useState([]);
  const [srcGroupList, setSrcGroupList] = useState([]);
  const [groupVal, setGroupVal] = useState("");
  const [searchKey, setSearchKey] = useState("");
  const [isGroup, setIsGroup] = useState(false);
  const [currentReport, setCurrentReport] = useState("participants");
  const [transactionsList, setTransactionsList] = useState([]);
  const [srcTransactionsList, setSrcTransactionsList] = useState([]);
  const [registrationTotals, setRegistrationTotals] = useState([]);
  const [srcRegistrationTotals, setSrcRegistrationTotals] = useState([]);
  const [unpaidRegistrations, setUnpaidRegistrations] = useState([]);
  const [srcUnpaidRegistrations, setSrcUnpaidRegistrations] = useState([]);
  const [visible, setVisible] = useState(false);
  const [userData, setUserData] = useState({});
  const [groupLabel, setGroupLabel] = useState("");
  const [telePhone, setTelephone] = useState("");
  const [cellPhone, setCellphone] = useState("");
  const [contactPhone, setContactPhone] = useState("");
  const [regGroupList, setRegGroupList] = useState([]);
  const [columnPreferences, setColumnPreferences] = useState(null);
  const [showColumnPicker, setShowColumnPicker] = useState(false);
  const [isSavingPreferences, setIsSavingPreferences] = useState(false);
  const [showTransactionDetail, setShowTransactionDetail] = useState(false);
  const [selectedTransactionId, setSelectedTransactionId] = useState(null);
  const [showInvoiceModal, setShowInvoiceModal] = useState(false);
  const [invoiceTransactionId, setInvoiceTransactionId] = useState(null);
  const [showRefundModal, setShowRefundModal] = useState(false);
  const [refundTransaction, setRefundTransaction] = useState(null);
  const [refundLoading, setRefundLoading] = useState(false);
  const [refundError, setRefundError] = useState(null);
  const [registrationMerchant, setRegistrationMerchant] = useState(null);
  const [facilityApplications, setFacilityApplications] = useState([]);
  const [srcFacilityApplications, setSrcFacilityApplications] = useState([]);
  const [showRejectModal, setShowRejectModal] = useState(false);
  const [rejectApplication, setRejectApplication] = useState(null);
  const [rejectLoading, setRejectLoading] = useState(false);
  const [viewApplication, setViewApplication] = useState(null);
  const [showViewModal, setShowViewModal] = useState(false);
  const [calendarEvents, setCalendarEvents] = useState([]);
  const [calendarLoading, setCalendarLoading] = useState(false);
  const [calendarFocusDate, setCalendarFocusDate] = useState(null);
  const [facilityFilter, setFacilityFilter] = useState("all");
  const [facilityReserveOptions, setFacilityReserveOptions] = useState([]);
  const [showReserveModal, setShowReserveModal] = useState(false);
  const [reserveForm, setReserveForm] = useState({
    facility: "",
    event_date: null,
    event_start_time: null,
    event_end_time: null,
    applicant_name: "",
    contact_email: "",
    contact_phone: "",
    event_type: "",
    notes: "",
  });

  const isFacilityRegistration = (appDataStore.curRegistration?.registration_type || "").toLowerCase() === "facility";

  useEffect(() => {
    if (appDataStore.curRegistration != undefined) {
      setFacilityFilter("all"); // Reset to 'all' (lowercase) when registration changes
      const isFacility = (appDataStore.curRegistration.registration_type || "").toLowerCase() === "facility";
      if (isFacility) {
        setCurrentReport("facility_applications");
        getFacilityApplications("all");
        loadFacilityReserveOptions();
      } else {
        setCurrentReport("participants");
        getRegistrationDetail();
        setFacilityReserveOptions([]);
      }
      getRegGroupData();
      loadColumnPreferences();
      loadRegistrationMerchant();
    } else {
      setUserList([]);
      setSrcList([]);
      setRegistrationMerchant(null);
      setFacilityApplications([]);
      setSrcFacilityApplications([]);
      setFacilityReserveOptions([]);
    }
    console.log("userDataStore:", userDataStore); // ADDED: Inspect userDataStore
  }, [appDataStore.curRegistration]);

  const loadFacilityReserveOptions = () => {
    if (!appDataStore?.curRegistration?.ID) {
      setFacilityReserveOptions([]);
      return;
    }
    const params = new URLSearchParams();
    params.append("token", userDataStore.token);
    params.append("registration_id", appDataStore.curRegistration.ID);
    apiGetRegistrationSettings(params)
      .then((res) => {
        const mainList = res?.registration_main_list || [];
        const facilities = mainList
          .map((item) => (item?.registration_title || "").trim())
          .filter((title) => title);
        const unique = Array.from(new Set(facilities));
        setFacilityReserveOptions(unique.sort((a, b) => a.localeCompare(b)));
      })
      .catch(() => {
        setFacilityReserveOptions([]);
      });
  };

  const formatPhoneInput = (value) => {
    if (!value) return "";
    const digits = value.replace(/\D/g, "").slice(0, 10);
    if (digits.length <= 3) return digits;
    if (digits.length <= 6) return `${digits.slice(0, 3)}-${digits.slice(3)}`;
    return `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6)}`;
  };

  const timeOptions = useMemo(() => {
    const options = [];
    for (let hour = 0; hour < 24; hour += 1) {
      for (let minute = 0; minute < 60; minute += 30) {
        const value = `${String(hour).padStart(2, "0")}:${String(minute).padStart(2, "0")}`;
        options.push({
          value,
          label: moment(value, "HH:mm").format("h:mm A"),
        });
      }
    }
    return options;
  }, []);

  const facilityOptions = useMemo(() => {
    const options = new Set();
    [...(srcFacilityApplications || []), ...(calendarEvents || [])].forEach((item) => {
      if (item?.facility) {
        options.add(item.facility);
      }
    });
    return Array.from(options).sort((a, b) => a.localeCompare(b));
  }, [srcFacilityApplications, calendarEvents]);

  const filterByFacility = (list) => {
    if (!facilityFilter || facilityFilter === "all") return list;
    if (!Array.isArray(list)) return [];
    const hasFacility = list.some((item) => item?.facility);
    if (!hasFacility) return list;
    return list.filter(
      (item) => (item?.facility || "").toLowerCase() === facilityFilter.toLowerCase()
    );
  };

  const getFacilityUnpaid = (list) => {
    if (!Array.isArray(list)) return [];
    return list.filter((item) => {
      const status = (item?.status || "").toLowerCase();
      const paid = item?.paid === 1 || item?.paid === "1";
      return status === "approved" && !paid;
    });
  };

  const getFacilityPaid = (list) => {
    if (!Array.isArray(list)) return [];
    return list.filter((item) => {
      const status = (item?.status || "").toLowerCase();
      const paid = item?.paid === 1 || item?.paid === "1";
      return status === "approved" && paid;
    });
  };

  const loadColumnPreferences = () => {
    const params = new URLSearchParams();
    params.append("token", userDataStore.token);
    params.append("sport_type", userDataStore?.sport_type);

    apiGetColumnPreferences(params)
      .then((res) => {
        if (res && res.preferences) {
          setColumnPreferences(res.preferences);
        } else {
          // Use defaults if no preferences saved
          const defaults = getDefaultColumnPreferences(userDataStore?.sport_type);
          setColumnPreferences(defaults);
        }
      })
      .catch((err) => {
        console.error("Failed to load column preferences:", err);
        // Use defaults on error
        const defaults = getDefaultColumnPreferences(userDataStore?.sport_type);
        setColumnPreferences(defaults);
      });
  };

  const loadRegistrationMerchant = () => {
    if (!appDataStore?.curRegistration?.ID) {
      setRegistrationMerchant(null);
      return;
    }

    const params = new URLSearchParams();
    params.append("registration_id", appDataStore.curRegistration.ID);
    if (userDataStore?.token) {
      params.append("token", userDataStore.token);
    }

    apiGetRegistrationPaymentSettings(params)
      .then((res) => {
        // axiosPost already validates success/status/result, so res is the valid response data
        const merchantValue = res?.merchant || res?.data?.merchant;
        if (!merchantValue) {
          message.error('Registration merchant is not configured. Please contact support.');
          setRegistrationMerchant(null);
          return;
        }

        setRegistrationMerchant(String(merchantValue).toLowerCase());
      })
      .catch((err) => {
        console.error("Failed to load registration payment settings:", err);
        setRegistrationMerchant(null);
      });
  };

  const handleSaveColumnPreferences = (preferences) => {
    const params = new URLSearchParams();
    params.append("token", userDataStore.token);
    params.append("sport_type", userDataStore?.sport_type);
    params.append("preferences", JSON.stringify(preferences));

    setIsSavingPreferences(true);

    apiSaveColumnPreferences(params)
      .then((res) => {
        setIsSavingPreferences(false);
        if (res) {
          message.success("Column preferences saved successfully");
          setColumnPreferences(preferences);
          setShowColumnPicker(false);
        }
      })
      .catch((err) => {
        setIsSavingPreferences(false);
        message.error("Failed to save column preferences: " + err);
      });
  };

  useEffect(() => {
    if (appDataStore.curRegistration == undefined) {
      setGroupVal("");
      return;
    }
    if (groupVal != "" && groupVal !== "registration_totals") {
      setIsGroup(true);
      getRegistrationByGroupDetail(groupVal);
      let label = "";
      if (groupVal == "timestamp") {
        label = "Reg Date";
      } else if (groupVal == "gender") {
        label = "Gender";
      } else if (groupVal == "discount_code") {
        label = "Discount Code";
      } else if (groupVal == "payment_method") {
        label = "Payment method";
      } else if (groupVal == "program") {
        label = "Program";
      }
      setGroupLabel(label);
    } else if (groupVal === "registration_totals") {
      setGroupLabel("Registration Totals");
    } else {
      setGroupLabel("");
    }
  }, [groupVal]);

  const onClear = () => {
    setSearchKey("");
    setGroupVal("");
    setIsGroup(false);
    getRegistrationDetail();
  };

  const onTransactionDetail = () => {
    history.push(ROUTE_REGISTRATION_DETAIL)
  }

  const onReportChange = (reportValue) => {
    setCurrentReport(reportValue);
    setSearchKey("");

    if (reportValue === "participants") {
      // Show default view with configurable columns
      setIsGroup(false);
      setGroupVal("");
      getRegistrationDetail();
    } else if (reportValue === "registrations") {
      // Show transactions list
      setIsGroup(false);
      setGroupVal("");
      getTransactionsList();
    } else if (reportValue === "registration_totals") {
      // Show Registration Totals report (grouped view initially)
      setIsGroup(true);
      setGroupVal("registration_totals");
      getRegistrationTotals();
    } else if (reportValue === "discount_code") {
      // Group by Discount Code
      setGroupVal("discount_code");
    } else if (reportValue === "reg_date") {
      // Group by Registration Date
      setGroupVal("timestamp");
    } else if (reportValue === "payment_method") {
      // Group by Payment Method
      setGroupVal("payment_method");
    } else if (reportValue === "group_program") {
      // Group by Program
      setGroupVal("program");
    } else if (reportValue === "unpaid") {
      // UnPaid Registrations
      setIsGroup(false);
      setGroupVal("");
      getUnpaidRegistrations();
    } else if (reportValue === "facility_applications") {
      // Facility Applications
      setIsGroup(false);
      setGroupVal("");
      getFacilityApplications("all");
    } else if (reportValue === "facility_calendar") {
      // Facility Calendar
      setIsGroup(false);
      setGroupVal("");
      getFacilityCalendar();
    }
  };

  const getTransactionsList = () => {
    setTransactionsList([]);
    setSrcTransactionsList([]);
    const params = new URLSearchParams();
    params.append("token", userDataStore.token);
    params.append("registration_id", appDataStore.curRegistration.ID);
    params.append("pay_status", 1); // Only show paid transactions
    setIsBusy(true);
    apiGetTransactionsList(params)
      .then((res) => {
        let list = [];
        if (Array.isArray(res)) {
          list = res;
        } else if (res && Array.isArray(res.data)) {
          list = res.data;
        }
        setTransactionsList(list);
        setSrcTransactionsList(list);
        setIsBusy(false);
      })
      .catch((err) => {
        setIsBusy(false);
        message.error(err);
      });
  };

  const getRegistrationTotals = () => {
    setRegistrationTotals([]);
    setSrcRegistrationTotals([]);
    const params = new URLSearchParams();
    params.append("token", userDataStore.token);
    params.append("club_id", appDataStore.curRegistration.beclutch_club_id);
    params.append("registration_id", appDataStore.curRegistration.ID);
    setIsBusy(true);
    apiGetRegistrationTotals(params)
      .then((res) => {
        let list = [];
        if (Array.isArray(res)) {
          list = res;
        } else if (res && Array.isArray(res.data)) {
          list = res.data;
        }
        setRegistrationTotals(list);
        setSrcRegistrationTotals(list);
        setIsBusy(false);
      })
      .catch((err) => {
        setIsBusy(false);
        message.error(err);
      });
  };

  const getUnpaidRegistrations = () => {
    setUnpaidRegistrations([]);
    setSrcUnpaidRegistrations([]);
    const params = new URLSearchParams();
    params.append("token", userDataStore.token);
    params.append("registration_id", appDataStore.curRegistration.ID);
    params.append("pay_status", 0);
    setIsBusy(true);
    apiGetTransactionsList(params)
      .then((res) => {
        let list = [];
        if (Array.isArray(res)) {
          list = res;
        } else if (res && Array.isArray(res.data)) {
          list = res.data;
        }
        // Backend filtered by pay_status when provided, but keep a safe client filter as well
        const unpaidList = list.filter(t => t.pay_status === 0 || t.pay_status === '0' || t.pay_status === null || t.pay_status === undefined);
        setUnpaidRegistrations(unpaidList);
        setSrcUnpaidRegistrations(unpaidList);
        setIsBusy(false);
      })
      .catch((err) => {
        setIsBusy(false);
        message.error(err);
      });
  };

  // Facility Application Functions
  const getFacilityApplications = (statusFilter) => {
    setFacilityApplications([]);
    setSrcFacilityApplications([]);
    const params = new URLSearchParams();
    params.append("token", userDataStore.token);
    params.append("registration_id", appDataStore.curRegistration.ID);
    params.append("status", statusFilter || "all");
    setIsBusy(true);
    apiGetFacilityApplications(params)
      .then((res) => {
        let list = [];
        if (Array.isArray(res)) {
          list = res;
        } else if (res && Array.isArray(res.data)) {
          list = res.data;
        }
        setFacilityApplications(list);
        setSrcFacilityApplications(list);
        setIsBusy(false);
      })
      .catch((err) => {
        setIsBusy(false);
        message.error(err);
      });
  };

  const getFacilityCalendar = (startDate, endDate) => {
    const params = new URLSearchParams();
    params.append("token", userDataStore.token);
    params.append("registration_id", appDataStore.curRegistration.ID);
    // Default to 3 months range if not specified
    if (startDate && endDate) {
      params.append("start_date", startDate);
      params.append("end_date", endDate);
    } else {
      const now = new Date();
      const start = new Date(now.getFullYear(), now.getMonth() - 1, 1);
      const end = new Date(now.getFullYear(), now.getMonth() + 3, 0);
      params.append("start_date", start.toISOString().split("T")[0]);
      params.append("end_date", end.toISOString().split("T")[0]);
    }
    setCalendarLoading(true);
    apiGetFacilityCalendar(params)
      .then((res) => {
        let list = [];
        if (Array.isArray(res)) {
          list = res;
        } else if (res && Array.isArray(res.data)) {
          list = res.data;
        }
        setCalendarEvents(list);
        setCalendarLoading(false);
      })
      .catch((err) => {
        setCalendarLoading(false);
        message.error("Failed to load calendar events");
      });
  };

  const onFacilityDateClick = (dateStr) => {
    if (!dateStr) return;
    setCurrentReport("facility_calendar");
    setCalendarFocusDate(dateStr);
    getFacilityCalendar(dateStr, dateStr);
  };

  const onOpenReserveModal = () => {
    setReserveForm({
      facility: "",
      event_date: null,
      event_start_time: null,
      event_end_time: null,
      applicant_name: "",
      contact_email: "",
      contact_phone: "",
      event_type: "",
      notes: "",
    });
    setShowReserveModal(true);
  };

  const onReserveSubmit = () => {
    if (!reserveForm.facility || !reserveForm.event_date || !reserveForm.event_start_time || !reserveForm.event_end_time || !reserveForm.applicant_name) {
      message.error("Please complete Facility, Date, Start, End, and Applicant Name.");
      return;
    }
    const startTime = moment.isMoment(reserveForm.event_start_time)
      ? reserveForm.event_start_time
      : moment(reserveForm.event_start_time, ["HH:mm", "HH:mm:ss", "h:mm A", "hh:mm A"], true);
    const endTime = moment.isMoment(reserveForm.event_end_time)
      ? reserveForm.event_end_time
      : moment(reserveForm.event_end_time, ["HH:mm", "HH:mm:ss", "h:mm A", "hh:mm A"], true);
    const params = new URLSearchParams();
    params.append("token", userDataStore.token);
    params.append("registration_id", appDataStore.curRegistration.ID);
    params.append("facility", reserveForm.facility);
    params.append("event_date", moment(reserveForm.event_date).format("YYYY-MM-DD"));
    params.append("event_start_time", startTime.isValid() ? startTime.format("HH:mm:ss") : "");
    params.append("event_end_time", endTime.isValid() ? endTime.format("HH:mm:ss") : "");
    params.append("applicant_name", reserveForm.applicant_name);
    params.append("contact_email", reserveForm.contact_email || "");
    params.append("contact_phone", reserveForm.contact_phone || "");
    params.append("event_type", reserveForm.event_type || "");
    params.append("notes", reserveForm.notes || "");

    setIsBusy(true);
    apiCreateFacilityReservation(params)
      .then((res) => {
        setIsBusy(false);
        const ok =
          res === true ||
          typeof res === "string" ||
          (res && (res.result === true || res.status === true || res.success === true));
        if (!ok) {
          message.error(res?.msg || "Failed to reserve facility");
          return;
        }
        message.success("Facility reserved.");
        setShowReserveModal(false);
        getFacilityCalendar();
        getFacilityApplications("all");
      })
      .catch((err) => {
        setIsBusy(false);
        message.error(err);
      });
  };

  const onApproveApplication = (application) => {
    Modal.confirm({
      title: 'Approve Application',
      content: `Approve ${application.applicant_name}'s application for ${application.facility}? A payment link will be emailed to ${application.contact_email}.`,
      okText: 'Approve',
      okType: 'primary',
      onOk() {
        const params = new URLSearchParams();
        params.append("token", userDataStore.token);
        params.append("application_id", application.id);
        params.append("registration_id", appDataStore.curRegistration.ID);
        setIsBusy(true);
        apiApproveFacilityApplication(params)
          .then((res) => {
            setIsBusy(false);
            const ok =
              res === true ||
              typeof res === "string" ||
              (res && (res.result === true || res.status === true || res.success === true));
            if (!ok) {
              message.error(res?.msg || "Failed to approve application");
              return;
            }
            message.success("Application approved. Payment link sent.");
            getFacilityApplications("all");
          })
          .catch((err) => {
            setIsBusy(false);
            message.error(err);
          });
      },
    });
  };

  const onRejectApplication = (application) => {
    setRejectApplication(application);
    setShowRejectModal(true);
  };

  const onViewApplication = (application) => {
    setViewApplication(application);
    setShowViewModal(true);
  };

  const onDeleteApplication = (application) => {
    Modal.confirm({
      title: "Delete Application",
      content: `Delete ${application.applicant_name || "this"} application? This cannot be undone.`,
      okText: "Delete",
      okType: "danger",
      onOk() {
        const params = new URLSearchParams();
        params.append("token", userDataStore.token);
        params.append("application_id", application.id);
        setIsBusy(true);
        apiDeleteFacilityApplication(params)
          .then((res) => {
            setIsBusy(false);
            const ok =
              res === true ||
              typeof res === "string" ||
              Array.isArray(res) ||
              (res && (res.result === true || res.status === true || res.success === true));
            if (!ok) {
              message.error(res?.msg || "Failed to delete application");
              return;
            }
            message.success("Application deleted.");
            getFacilityApplications("all");
          })
          .catch((err) => {
            setIsBusy(false);
            message.error(err);
          });
      },
    });
  };

  const handleRejectSubmit = (reason) => {
    const params = new URLSearchParams();
    params.append("token", userDataStore.token);
    params.append("application_id", rejectApplication.id);
    params.append("registration_id", appDataStore.curRegistration.ID);
    params.append("reject_reason", reason || "");
    setRejectLoading(true);
    apiRejectFacilityApplication(params)
      .then((res) => {
        setRejectLoading(false);
        const ok =
          res === true ||
          typeof res === "string" ||
          (res && (res.result === true || res.status === true || res.success === true));
        if (!ok) {
          message.error(res?.msg || "Failed to reject application");
          return;
        }
        message.success("Application rejected.");
        setShowRejectModal(false);
        setRejectApplication(null);
        getFacilityApplications("all");
      })
      .catch((err) => {
        setRejectLoading(false);
        message.error(err);
      });
  };

  const onMarkAsPaid = (transactionId) => {
    const params = new URLSearchParams();
    params.append("token", userDataStore.token);
    params.append("transaction_id", transactionId);
    params.append("pay_status", 1);
    setIsBusy(true);
    apiUpdateTransactionPayStatus(params)
      .then((res) => {
        setIsBusy(false);
        const ok = !!(
          (res && (res.result === true || res.status === true || res.success === true)) ||
          (typeof res === "string" && /pay status updated|success/i.test(res))
        );
        if (ok) {
          message.success("Marked as paid");
          getUnpaidRegistrations();
        } else {
          message.error(res?.msg || res?.message_field_name || "Failed to update status");
        }
      })
      .catch((err) => {
        setIsBusy(false);
        message.error(err);
      });
  };

  const onVoid = (transaction) => {
    Modal.confirm({
      title: 'Void Transaction',
      content: `Are you sure you want to void transaction ${transaction.transaction_id}? This action cannot be undone.`,
      okText: 'Void',
      okType: 'danger',
      cancelText: 'Cancel',
      onOk() {
        handleVoid(transaction);
      },
    });
  };

  const handleVoid = (transaction) => {
    setIsBusy(true);
    const params = {
      token: userDataStore.token,
      original_transaction_id: transaction.payment_txn_id,
      authorization_code: transaction.authorization_code || '',
      registration_id: appDataStore.curRegistration.ID,
      domain: window.location.hostname,
      entered_by: userDataStore.user_name || userDataStore.username || 'admin',
    };

    // Route to correct API based on merchant
    const voidApi = registrationMerchant === 'stax' ? apiStaxVoidTransaction : apiVoidTransaction;

    voidApi(params)
      .then((res) => {
        setIsBusy(false);
        const ok = !!(res && (res.result === true || res.status === true));
        if (ok) {
          message.success('Transaction voided successfully');
          getUnpaidRegistrations();
        } else {
          message.error(res?.message_field_name || res?.msg || 'Failed to void transaction');
        }
      })
      .catch((err) => {
        setIsBusy(false);
        message.error(err.message || 'Failed to void transaction');
      });
  };

  const onRefund = (transaction) => {
    setRefundTransaction(transaction);
    setRefundError(null);
    setShowRefundModal(true);
  };

  const handleRefund = ({ authorization_amount, participant_ids = [], program_ids = [], is_full_refund = false }) => {
    setRefundLoading(true);
    setRefundError(null);

    const params = new URLSearchParams();
    params.append("token", userDataStore.token);
    params.append("original_transaction_id", refundTransaction.payment_txn_id);
    params.append("authorization_amount", authorization_amount);
    params.append("registration_id", appDataStore.curRegistration.ID);
    params.append("domain", window.location.hostname);
    params.append("entered_by", userDataStore.user_name || userDataStore.username || 'admin');
    params.append("is_full_refund", is_full_refund ? '1' : '0');
    participant_ids.forEach(id => params.append("participant_ids[]", id));
    program_ids.forEach(id => params.append("program_ids[]", id));

    // Route to correct API based on merchant
    const refundApi = registrationMerchant === 'stax' ? apiStaxRefundTransaction : apiRefundTransaction;

    refundApi(params)
      .then((res) => {
        setRefundLoading(false);
        const ok = !!(res && (res.result === true || res.status === true));
        if (ok) {
          message.success(`Refund of $${parseFloat(authorization_amount).toFixed(2)} processed successfully`);
          setShowRefundModal(false);
          setRefundTransaction(null);
          getUnpaidRegistrations();
        } else {
          setRefundError(res?.message_field_name || res?.msg || 'Failed to process refund');
        }
      })
      .catch((err) => {
        setRefundLoading(false);
        setRefundError(err.message || 'Failed to process refund');
      });
  };

  const onInvoice = (transactionId) => {
    setInvoiceTransactionId(transactionId);
    setShowInvoiceModal(true);
  };

  const onEmailReceipt = async (transactionId) => {
    const params = new URLSearchParams();
    params.append("token", userDataStore.token);
    params.append("transaction_id", transactionId);
    params.append("registration_id", appDataStore.curRegistration?.ID);

    try {
      await apiSendInvoiceReceipt(params);
      message.success("Invoice emailed successfully.");
    } catch (err) {
      message.error(err || "Failed to email invoice");
    }
  };

  const onDeleteTransaction = (transactionId) => {
    const params = new URLSearchParams();
    params.append("token", userDataStore.token);
    params.append("id", transactionId);

    setIsBusy(true);
    apiDeleteTransaction(params)
      .then(() => {
        setIsBusy(false);
        message.success("Transaction deleted.");
        getTransactionsList();
      })
      .catch((err) => {
        setIsBusy(false);
        message.error(err || "Failed to delete transaction");
      });
  };

  const onSearch = (v) => {
    setSearchKey(v);
    let tmpList = [];
    if (isGroup) {
      tmpList = [...srcGroupList];
    } else if (currentReport === "registrations") {
      tmpList = [...srcTransactionsList];
    } else if (currentReport === "registration_totals") {
      tmpList = [...srcRegistrationTotals];
    } else if (currentReport === "unpaid") {
      tmpList = [...srcUnpaidRegistrations];
    } else if (currentReport === "facility_applications") {
      tmpList = [...srcFacilityApplications];
    } else {
      tmpList = [...srcList];
    }
    if (isGroup) {
      if (v == "") {
        setGroupList(tmpList);
      } else {
        setGroupList(
          tmpList.filter((x) => {
            if (x.fee_label.toLowerCase().includes(v.toLowerCase())) {
              return x;
            }
          })
        );
      }
    } else if (currentReport === "registrations") {
      if (v == "") {
        setTransactionsList(tmpList);
      } else {
        setTransactionsList(
          tmpList.filter((x) => {
            const searchLower = v.toLowerCase();
            return (
              (x.parent_first && x.parent_first.toLowerCase().includes(searchLower)) ||
              (x.parent_last && x.parent_last.toLowerCase().includes(searchLower)) ||
              (x.p_email && x.p_email.toLowerCase().includes(searchLower))
            );
          })
        );
      }
    } else if (currentReport === "registration_totals") {
      if (v == "") {
        setRegistrationTotals(tmpList);
      } else {
        setRegistrationTotals(
          tmpList.filter((x) => {
            const searchLower = v.toLowerCase();
            return (
              (x.name && x.name.toLowerCase().includes(searchLower)) ||
              (x.type && x.type.toLowerCase().includes(searchLower))
            );
          })
        );
      }
    } else if (currentReport === "unpaid") {
      if (v == "") {
        setUnpaidRegistrations(tmpList);
      } else {
        setUnpaidRegistrations(
          tmpList.filter((x) => {
            const searchLower = v.toLowerCase();
            return (
              (x.parent_first && x.parent_first.toLowerCase().includes(searchLower)) ||
              (x.parent_last && x.parent_last.toLowerCase().includes(searchLower)) ||
              (x.p_email && x.p_email.toLowerCase().includes(searchLower))
            );
          })
        );
      }
    } else if (currentReport === "facility_applications") {
      if (v == "") {
        setFacilityApplications(srcFacilityApplications);
      } else {
        setFacilityApplications(
          srcFacilityApplications.filter((x) => {
            const searchLower = v.toLowerCase();
            return (
              (x.applicant_name && x.applicant_name.toLowerCase().includes(searchLower)) ||
              (x.contact_email && x.contact_email.toLowerCase().includes(searchLower)) ||
              (x.facility && x.facility.toLowerCase().includes(searchLower))
            );
          })
        );
      }
    } else {
      if (v == "") {
        setUserList(tmpList);
      } else {
        if (userDataStore?.sport_type == "camp") {
          tmpList = tmpList.filter((x) => {
            if (x.name.toLowerCase().includes(v.toLowerCase())) {
              return x;
            }
          });
        } else {
          tmpList = tmpList.filter((x) => {
            if (
              x.p_email.toLowerCase().includes(v.toLowerCase()) ||
              x.name.toLowerCase().includes(v.toLowerCase())
            ) {
              return x;
            }
          });
        }
        setUserList(tmpList);
      }
    }
  };

  const getRegGroupData = () => {
    const params = new URLSearchParams();
    params.append("token", userDataStore.token);
    params.append("sport_type", userDataStore?.sport_type);
    params.append("id", appDataStore.curRegistration.ID);
    console.log("Calling apiGetRegGroupData with params:", Object.fromEntries(params.entries()));
    apiGetRegGroupData(params)
      .then((res) => {
        if (res.length > 0) {
          setRegGroupList(res);
        } else {
          setRegGroupList([]);
        }
      })
      .catch((err) => {
        setIsBusy(false);
        message.error(err);
      });
  };

  const getRegistrationDetail = () => {
    setUserList([]);
    setSrcList([]);
    const params = new URLSearchParams();
    params.append("token", userDataStore.token);
    params.append("sport_type", userDataStore?.sport_type);
    params.append("registration_id", appDataStore.curRegistration.ID);
    setIsBusy(true);
    console.log("Calling apiGetRegistrationDetail with params:", Object.fromEntries(params.entries()));
    apiGetRegistrationDetail(params)
      .then((res) => {
        console.log("API Response Received:", res); // <-- ADDED: Log the raw response
        if (!res || !res.detail) {
          console.error("API response is invalid or missing 'detail' array.");
          setUserList([]);
          setSrcList([]);
          setIsBusy(false);
          message.error("Received invalid data from server.");
          return;
        }
        // Process the data to ensure immunization_verified is a boolean
        const processedData = res.detail.map(item => {
          // Use immun_verified if immunization_verified is not present
          const iv = item.immunization_verified !== undefined ? item.immunization_verified : item.immun_verified;
          const processed = {
            ...item,
            immunization_verified: iv === 1 || iv === true || iv === "1" || iv === "true"
          };
          return processed;
        });
        console.log(`Processing ${processedData.length} rows for the table.`); // <-- ADDED: Log the count
        setUserList(processedData);
        setSrcList(processedData);
        let tmpList = [...res.group_list];
        let tmpSrcList = tmpList.map((x, index) => {
          return {
            id: x.ID,
            title: x.registration_group_short_name,
            description: x.registration_group_name,
            price: x.registration_group_fee,
            checked: false,
            discount_available: x.discount_available,
          };
        });
        setTripList(tmpSrcList);
        setIsBusy(false);
      })
      .catch((err) => {
        console.error("Failed to fetch registration details:", err); // <-- ADDED: Better error logging
        setIsBusy(false);
        message.error(err);
      });
  };
  const getRegistrationByGroupDetail = (group) => {
    setGroupList([]);
    setSrcGroupList([]);
    const params = new URLSearchParams();
    params.append("token", userDataStore.token);
    params.append("sport_type", userDataStore?.sport_type);
    params.append("id", appDataStore.curRegistration.ID);
    params.append("group", group);
    setIsBusy(true);
    console.log("Calling apiGetRegistrationDetailByGroup with params:", Object.fromEntries(params.entries()));
    apiGetRegistrationDetailByGroup(params)
      .then((res) => {
        setGroupList(res);
        setSrcGroupList(res);
        setIsBusy(false);
      })
      .catch((err) => {
        setIsBusy(false);
        message.error(err);
      });
  };
  const updateData = () => {
    const params = new URLSearchParams();
    params.append("token", userDataStore.token);
    params.append("sport_type", userDataStore?.sport_type);
    params.append("id", userData.id);
    params.append("first_name", userData.first_name);
    params.append("last_name", userData.last_name);
    params.append("tele_phone", userData.tele_phone);
    params.append("birthday", userData.birthday);
    params.append("address", userData.address);
    params.append("city", userData.city);
    params.append("state", userData.state);
    params.append("gender", userData.gender);
    params.append("zip", userData.zip);
    params.append("grade", userData.grade);
    params.append("fee_label", userData.fee_label);
    params.append("p_first_name", userData.p_first_name);
    params.append("p_home_phone", userData.p_home_phone);
    params.append("p_last_name", userData.p_last_name);
    params.append("p_cell_phone", userData.p_cell_phone);
    params.append("p_relation", userData.p_relation);
    params.append("p_email", userData.p_email);
    params.append("c_first_name", userData.c_first_name);
    params.append("c_last_name", userData.c_last_name);
    params.append("c_email", userData.c_email);
    params.append("c_cell_phone", userData.c_cell_phone);
    console.log("Calling apiUpdateRegInfo with params:", Object.fromEntries(params.entries()));
    setIsBusy(true);
    apiUpdateRegInfo(params)
      .then((res) => {
        let selData = {
          ...userData,
          name: userData.first_name + " " + userData.last_name,
        };
        let tmpList = [...userList];
        let selId = tmpList.findIndex((x) => (x.id == userData.id));
        tmpList[selId] = selData;
        setUserList(tmpList);
        let tmpSrcList = [...srcList];
        let selsrcId = tmpSrcList.findIndex((x) => (x.id == userData.id));
        tmpSrcList[selsrcId] = selData;
        setSrcList(tmpSrcList);
        message.success("Updated successfully.");
        setIsBusy(false);
      })
      .catch((err) => {
        setIsBusy(false);
        message.error(err);
      });
  };
  const updateCampData = () => {
    const params = new URLSearchParams();
    params.append("token", userDataStore.token);
    params.append("sport_type", userDataStore?.sport_type);
    params.append("id", userData.id);

    console.log('Updating camp data with userData:', userData);
    console.log('immun_verified value:', userData.immun_verified);

    params.append("camper_first_name", userData.camper_first_name);
    params.append("camper_last_name", userData.camper_last_name);
    params.append("camper_age", userData.camper_age);
    params.append("camper_grade", userData.camper_grade);
    params.append("camper_street", userData.camper_street);
    params.append("camper_city", userData.camper_city);
    params.append("camper_state", userData.camper_state);
    params.append("camper_zip", userData.camper_zip);
    params.append("camper_t_shirt", userData.camper_t_shirt);
    params.append("camper_health", userData.camper_health);
    params.append("camper_sel_trip", userData.camper_sel_trip);
    params.append("p_first_name", userData.p_first_name);
    params.append("p_last_name", userData.p_last_name);
    params.append("p_relation", userData.p_relation);
    params.append("p_email", userData.p_email);
    params.append("p_cell_phone", userData.p_cell_phone);
    params.append("p_home_phone", userData.p_home_phone);
    params.append("c_first_name", userData.c_first_name);
    params.append("c_last_name", userData.c_last_name);
    params.append("c_email", userData.c_email);
    params.append("c_cell_phone", userData.c_cell_phone);
    // Send immun_verified as well
    params.append("immun_verified", userData.immun_verified);
    
    console.log('Calling apiUpdateCampRegInfo with params:', Object.fromEntries(params.entries()));
    setIsBusy(true);
    apiUpdateCampRegInfo(params)
      .then((res) => {
        console.log('Update response:', res);
        let selData = {
          ...userData,
          name: userData.camper_first_name + " " + userData.camper_last_name,
          immunization_verified: userData.immunization_verified
        };
        let tmpList = [...userList];
        let selId = tmpList.findIndex((x) => (x.id == userData.id));
        tmpList[selId] = selData;
        setUserList(tmpList);
        let tmpSrcList = [...srcList];
        let selsrcId = tmpSrcList.findIndex((x) => (x.id == userData.id));
        tmpSrcList[selsrcId] = selData;
        setSrcList(tmpSrcList);
        message.success("Updated successfully.");
        setIsBusy(false);
      })
      .catch((err) => {
        console.error('Update error:', err);
        setIsBusy(false);
        message.error(err);
      });
  };
  const deleteData = (id) => {
    const params = new URLSearchParams();
    params.append("token", userDataStore.token);
    params.append("sport_type", userDataStore?.sport_type);
    params.append("id", id);
    setIsBusy(true);
    console.log("Calling apiDeleteRegInfo with params:", Object.fromEntries(params.entries()));
    apiDeleteRegInfo(params)
      .then((res) => {
        let tmpList = [...userList];
        setUserList(tmpList.filter((x) => x.id != id));
        let tmpSrcList = [...srcList];
        setSrcList(tmpSrcList.filter((x) => x.id != id));
        message.success("Deleted successfully.");
        setIsBusy(false);
      })
      .catch((err) => {
        setIsBusy(false);
        message.error(err);
      });
  };
  const onDetail = (label) => {
    setUserList([]);
    setSrcList([]);
    const params = new URLSearchParams();
    params.append("token", userDataStore.token);
    params.append("sport_type", userDataStore?.sport_type);
    params.append("registration_id", appDataStore.curRegistration.ID);
    params.append("label", label);
    params.append("type", groupVal);
    setIsBusy(true);
    console.log("Calling apiGetRegistrationDetailByLabel with params:", Object.fromEntries(params.entries()));
    apiGetRegistrationDetailByLabel(params)
      .then((res) => {
        if (res.detail != undefined) {
          setUserList(res.detail);
          setSrcList(res.detail);
        }
        setIsBusy(false);
        setIsGroup(false);
      })
      .catch((err) => {
        setIsBusy(false);
        message.error(err);
      });
  };

  const onRegistrationTotalsDetail = (record) => {
    // When a row is clicked in Registration Totals, fetch the transactions for that item
    setTransactionsList([]);
    setSrcTransactionsList([]);
    const params = new URLSearchParams();
    params.append("token", userDataStore.token);
    params.append("registration_type", record.type); // "registration" or "program"
    params.append("registration_id", record.id); // The specific registration_main or program ID
    setIsBusy(true);
    apiGetRegistrationTotalParticipants(params)
      .then((res) => {
        let list = [];
        if (Array.isArray(res)) {
          list = res;
        } else if (res && Array.isArray(res.data)) {
          list = res.data;
        }
        setTransactionsList(list);
        setSrcTransactionsList(list);
        setIsBusy(false);
        setIsGroup(false);
        setGroupLabel(`${record.name} (${record.type === 'registration' ? 'Registration' : 'Program'})`);
      })
      .catch((err) => {
        setIsBusy(false);
        message.error(err);
      });
  };

  const onBackToGroup = () => {
    setIsGroup(true);
    setSearchKey("");
    if (groupVal === "registration_totals") {
      getRegistrationTotals();
    } else {
      getRegistrationByGroupDetail(groupVal);
    }
  };
  const onVisible = (info) => {
    setVisible(true);
    setTelephone(info.tele_phone);
    setCellphone(info.p_cell_phone);
    setContactPhone(info.c_cell_phone);
    
    // Create a copy of info to modify
    let processedInfo = { ...info };
    
    // Ensure immunization_verified is properly initialized
    processedInfo.immunization_verified = processedInfo.immunization_verified === 1 || processedInfo.immunization_verified === true;
    
    setUserData({
      ...processedInfo,
      p_home_phone: processedInfo.p_home_phone || ""
    });
  };

  const onRowClick = (record) => {
    // For camp sport type, show transaction detail modal
    if (userDataStore?.sport_type === "camp" && record.transaction_id) {
      setSelectedTransactionId(record.transaction_id);
      setShowTransactionDetail(true);
    }
  };

  const handlePrint = () => {
    window.print();
  };

  const formatFieldLabel = (key) =>
    String(key)
      .replace(/_/g, " ")
      .replace(/\b\w/g, (c) => c.toUpperCase());

  const formatDateValue = (value) => {
    if (!value) return "-";
    const parsed = moment(
      value,
      [
        "MM/DD/YYYY",
        "MM/DD/YY",
        "YYYY-MM-DD",
        "YYYY/MM/DD",
        "YYYY-MM-DD HH:mm:ss",
        "YYYY/MM/DD HH:mm:ss",
        moment.ISO_8601,
      ],
      true
    );
    return parsed.isValid() ? parsed.format("MM/DD/YYYY") : value;
  };

  const formatTimeValue = (value) => {
    if (!value) return "-";
    const parsed = moment(value, ["HH:mm:ss", "HH:mm", "h:mm A", "hh:mm A"], true);
    return parsed.isValid() ? parsed.format("hh:mm A") : value;
  };

  return (
    <CommonDivWidget>
      <Spin spinning={isBusy}>
        <div className="registration-page">
          <ClubBoxWidget />
          <div style={{ paddingLeft: 10, paddingRight: 10 }}>
            <Divider
              style={{ borderTop: "4px solid var(--mainColor)" }}
            ></Divider>
            {(() => {
              const hideColumns = ["discount_code", "reg_date", "payment_method", "group_program", "registration_totals", "facility_applications", "facility_calendar"].includes(currentReport);
              const columnHandler = hideColumns ? undefined : () => setShowColumnPicker(true);
              return (
            <SearchWidget
              dataList={
                currentReport === "facility_applications"
                  ? filterByFacility(facilityApplications)
                  : currentReport === "facility_calendar"
                  ? filterByFacility(calendarEvents)
                  : isFacilityRegistration && currentReport === "unpaid"
                  ? getFacilityUnpaid(filterByFacility(facilityApplications))
                  : isFacilityRegistration && currentReport === "registrations"
                  ? getFacilityPaid(filterByFacility(facilityApplications))
                  : currentReport === "registrations"
                  ? filterByFacility(transactionsList)
                  : currentReport === "registration_totals"
                  ? registrationTotals
                  : currentReport === "unpaid"
                  ? filterByFacility(unpaidRegistrations)
                  : userList
              }
              groupList={groupList}
              isGroup={isGroup}
              onSearch={onSearch}
              searchKey={searchKey}
              setSearchKey={setSearchKey}
              sport_type={userDataStore?.sport_type}
              onColumnSettings={columnHandler}
              currentReport={currentReport}
              onReportChange={onReportChange}
              onPrint={handlePrint}
              registrationType={appDataStore.curRegistration?.registration_type}
              facilityOptions={facilityOptions}
              facilityFilter={facilityFilter}
              onFacilityFilter={setFacilityFilter}
            />
              );
            })()}
            {!isGroup && groupVal && (
              <div style={{ marginBottom: 16, marginTop: 16 }}>
                <CommonButton
                  onClick={onBackToGroup}
                  style={{ display: 'flex', alignItems: 'center', gap: 8 }}
                >
                  <span>←</span>
                  <span>Back to {groupLabel} Report</span>
                </CommonButton>
              </div>
            )}
            {useMemo(() => {
              if (currentReport === "facility_calendar") {
                return (
                  <FacilityCalendarWidget
                    events={filterByFacility(calendarEvents)}
                    loading={calendarLoading}
                    onDateRangeChange={(start, end) => getFacilityCalendar(start, end)}
                    focusDate={calendarFocusDate}
                    onReserveClick={onOpenReserveModal}
                  />
                );
              }
              if (currentReport === "facility_applications") {
                return (
                  <FacilityApplicationsTable
                    dataList={filterByFacility(facilityApplications)}
                    onApprove={onApproveApplication}
                    onReject={onRejectApplication}
                    onView={onViewApplication}
                    onDelete={onDeleteApplication}
                    onEventDateClick={onFacilityDateClick}
                  />
                );
              }
              if (isGroup && currentReport !== "registration_totals") {
                return (
                  <GroupTable
                    dataList={groupList}
                    group={groupLabel}
                    onDetail={onDetail}
                    sport_type={userDataStore?.sport_type}
                  />
                );
              }
              if (currentReport === "registrations") {
                if (isFacilityRegistration) {
                  return (
                    <FacilityApplicationsTable
                      dataList={getFacilityPaid(filterByFacility(facilityApplications))}
                      onApprove={onApproveApplication}
                      onReject={onRejectApplication}
                      onView={onViewApplication}
                      onDelete={onDeleteApplication}
                      onEventDateClick={onFacilityDateClick}
                    />
                  );
                }
                return (
                  <RegistrationsTable
                    dataList={filterByFacility(transactionsList)}
                    onRowClick={onRowClick}
                    onInvoice={onInvoice}
                    merchant={registrationMerchant}
                    onVoid={onVoid}
                    onRefund={onRefund}
                    onDelete={onDeleteTransaction}
                  />
                );
              }
              if (currentReport === "unpaid") {
                if (isFacilityRegistration) {
                  return (
                    <FacilityApplicationsTable
                      dataList={getFacilityUnpaid(filterByFacility(facilityApplications))}
                      onApprove={onApproveApplication}
                      onReject={onRejectApplication}
                      onView={onViewApplication}
                      onDelete={onDeleteApplication}
                      onEventDateClick={onFacilityDateClick}
                    />
                  );
                }
                return (
                  <RegistrationsTable
                    dataList={filterByFacility(unpaidRegistrations)}
                    onRowClick={onRowClick}
                    onMarkAsPaid={onMarkAsPaid}
                    onInvoice={onInvoice}
                    onDelete={onDeleteTransaction}
                  />
                );
              }
              if (currentReport === "registration_totals") {
                if (isGroup) {
                  return (
                    <RegistrationTotalsTable
                      data={registrationTotals}
                      isBusy={isBusy}
                      onDetail={onRegistrationTotalsDetail}
                    />
                  );
                }
                // Show individual transactions when a totals row is clicked
                return (
                  <RegistrationsTable
                    dataList={transactionsList}
                    onRowClick={onRowClick}
                    onInvoice={onInvoice}
                    merchant={registrationMerchant}
                    onVoid={onVoid}
                    onRefund={onRefund}
                  />
                );
              }
              return (
                <RegFormTable
                  dataList={userList}
                  setVisible={onVisible}
                  setUserData={setUserData}
                  deleteData={deleteData}
                  sport_type={userDataStore?.sport_type}
                  columnPreferences={columnPreferences}
                  onRowClick={onRowClick}
                />
              );
            }, [
              isGroup,
              groupList,
              userList,
              groupLabel,
              userDataStore?.sport_type,
              columnPreferences,
              onRowClick,
              currentReport,
              transactionsList,
              unpaidRegistrations,
              registrationTotals,
              facilityApplications,
              calendarEvents,
              calendarLoading,
              isBusy,
            ])}
          </div>
          {userDataStore?.sport_type == "camp" ? (
            <CampRightDetailWidget
              visible={visible}
              setVisible={setVisible}
              userData={userData}
              setUserData={setUserData}
              updateData={updateCampData}
              telePhone={telePhone}
              setTelephone={setTelephone}
              cellPhone={cellPhone}
              setCellphone={setCellphone}
              contactPhone={contactPhone}
              setContactPhone={setContactPhone}
              regGroupList={regGroupList}
              tripList={tripList}
            />
          ) : (
            <RightDetailWidget
              visible={visible}
              setVisible={setVisible}
              userData={userData}
              setUserData={setUserData}
              updateData={updateData}
              telePhone={telePhone}
              setTelephone={setTelephone}
              cellPhone={cellPhone}
              setCellphone={setCellphone}
              contactPhone={contactPhone}
              setContactPhone={setContactPhone}
              regGroupList={regGroupList}
              tripList={tripList}
            />
          )}
        </div>
      </Spin>
      <ColumnPickerModal
        visible={showColumnPicker}
        onClose={() => setShowColumnPicker(false)}
        onSave={handleSaveColumnPreferences}
        sportType={userDataStore?.sport_type}
        currentPreferences={columnPreferences}
        isBusy={isSavingPreferences}
      />
      <TransactionDetailModal
        visible={showTransactionDetail}
        onClose={() => setShowTransactionDetail(false)}
        transactionId={selectedTransactionId}
      />
      <InvoiceModal
        visible={showInvoiceModal}
        onClose={() => setShowInvoiceModal(false)}
        transactionId={invoiceTransactionId}
        registrationName={appDataStore.curRegistration?.registration_name}
        onEmailReceipt={onEmailReceipt}
      />
      <RefundModal
        visible={showRefundModal}
        onClose={() => setShowRefundModal(false)}
        onRefund={handleRefund}
        transaction={refundTransaction}
        registrationName={appDataStore.curRegistration?.registration_name}
        loading={refundLoading}
        error={refundError}
      />
      <Modal
        title="Reserve Facility"
        open={showReserveModal}
        onCancel={() => setShowReserveModal(false)}
        onOk={onReserveSubmit}
        okText="Reserve"
        confirmLoading={isBusy}
      >
        <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
          <Select
            placeholder="Facility *"
            value={reserveForm.facility || undefined}
            onChange={(v) => setReserveForm({ ...reserveForm, facility: v })}
            options={(facilityReserveOptions || []).map((facility) => ({
              value: facility,
              label: facility,
            }))}
            showSearch
            optionFilterProp="label"
            style={{ width: "100%" }}
          />
          <DatePicker
            placeholder="Event Date *"
            value={reserveForm.event_date}
            onChange={(v) => setReserveForm({ ...reserveForm, event_date: v })}
            style={{ width: "100%" }}
          />
          <Select
            placeholder="Start Time *"
            value={reserveForm.event_start_time || undefined}
            onChange={(v) => setReserveForm({ ...reserveForm, event_start_time: v })}
            options={timeOptions}
            showSearch
            optionFilterProp="label"
            style={{ width: "100%" }}
          />
          <Select
            placeholder="End Time *"
            value={reserveForm.event_end_time || undefined}
            onChange={(v) => setReserveForm({ ...reserveForm, event_end_time: v })}
            options={timeOptions}
            showSearch
            optionFilterProp="label"
            style={{ width: "100%" }}
          />
          <Input
            placeholder="Applicant Name *"
            value={reserveForm.applicant_name}
            onChange={(e) => setReserveForm({ ...reserveForm, applicant_name: e.target.value })}
          />
          <Input
            placeholder="Contact Email"
            value={reserveForm.contact_email}
            onChange={(e) => setReserveForm({ ...reserveForm, contact_email: e.target.value })}
          />
          <Input
            placeholder="Contact Phone"
            value={reserveForm.contact_phone}
            inputMode="tel"
            type="tel"
            onChange={(e) =>
              setReserveForm({
                ...reserveForm,
                contact_phone: formatPhoneInput(e.target.value),
              })
            }
          />
          <Input
            placeholder="Event Type"
            value={reserveForm.event_type}
            onChange={(e) => setReserveForm({ ...reserveForm, event_type: e.target.value })}
          />
          <Input.TextArea
            placeholder="Notes"
            value={reserveForm.notes}
            onChange={(e) => setReserveForm({ ...reserveForm, notes: e.target.value })}
            rows={3}
          />
        </div>
      </Modal>
      <Modal
        title="Facility Application Details"
        open={showViewModal}
        onCancel={() => setShowViewModal(false)}
        footer={null}
        width={640}
      >
        {viewApplication && (
          <Descriptions column={1} bordered size="small">
            <Descriptions.Item label="Applicant">{viewApplication.applicant_name || "-"}</Descriptions.Item>
            <Descriptions.Item label="Facility">{viewApplication.facility || "-"}</Descriptions.Item>
            <Descriptions.Item label="Event Date">
              {formatDateValue(viewApplication.event_date)}
            </Descriptions.Item>
            <Descriptions.Item label="Time">
              {formatTimeValue(viewApplication.event_start_time)} - {formatTimeValue(viewApplication.event_end_time)}
            </Descriptions.Item>
            <Descriptions.Item label="Hours">{viewApplication.total_hours || "-"}</Descriptions.Item>
            <Descriptions.Item label="Amount">
              ${parseFloat(viewApplication.total_amount || 0).toFixed(2)}
            </Descriptions.Item>
            <Descriptions.Item label="Alcohol">
              {(() => {
                const val = viewApplication.alcohol;
                if (val === undefined || val === null || val === "") return "-";
                const normalized = `${val}`.toLowerCase();
                if (normalized === "1" || normalized === "yes" || normalized === "true") return "Yes";
                if (normalized === "0" || normalized === "no" || normalized === "false") return "No";
                return val;
              })()}
            </Descriptions.Item>
            <Descriptions.Item label="Status">{viewApplication.status || "pending"}</Descriptions.Item>
            <Descriptions.Item label="Email">{viewApplication.contact_email || "-"}</Descriptions.Item>
            <Descriptions.Item label="Phone">{viewApplication.contact_phone || "-"}</Descriptions.Item>
            {viewApplication.event_type && (
              <Descriptions.Item label="Event Type">{viewApplication.event_type}</Descriptions.Item>
            )}
            {viewApplication.reject_reason && (
              <Descriptions.Item label="Reject Reason">{viewApplication.reject_reason}</Descriptions.Item>
            )}
            {viewApplication.created_at && (
              <Descriptions.Item label="Submitted">
                {formatDateValue(viewApplication.created_at)}
              </Descriptions.Item>
            )}
            {Object.entries(viewApplication)
              .filter(([key, value]) => {
                const hiddenKeys = [
                  "id",
                  "registration_id",
                  "applicant_name",
                  "facility",
                  "event_date",
                  "event_start_time",
                  "event_end_time",
                  "total_hours",
                  "total_amount",
                  "alcohol",
                  "status",
                  "contact_email",
                  "contact_phone",
                  "event_type",
                  "reject_reason",
                  "created_at",
                  "payment_token",
                  "payment_token_expires_at",
                  "updated_at",
                  "key",
                ];
                if (hiddenKeys.includes(key)) return false;
                if (value === undefined || value === null || value === "") return false;
                return true;
              })
              .map(([key, value]) => (
                <Descriptions.Item key={key} label={formatFieldLabel(key)}>
                  {(() => {
                    if (typeof value === "string") {
                      const lowerKey = key.toLowerCase();
                      if (lowerKey.includes("time")) return formatTimeValue(value);
                      if (lowerKey.includes("date") || lowerKey.endsWith("_at")) return formatDateValue(value);
                      return value;
                    }
                    return JSON.stringify(value);
                  })()}
                </Descriptions.Item>
              ))}
          </Descriptions>
        )}
      </Modal>
      <RejectReasonModal
        visible={showRejectModal}
        onClose={() => { setShowRejectModal(false); setRejectApplication(null); }}
        onReject={handleRejectSubmit}
        application={rejectApplication}
        loading={rejectLoading}
      />
    </CommonDivWidget>
  );
};



export default RegistrationPage;
